<template>
    <main>
        <div class="container">
            <img src="../assets/divider.svg" style="width: 100%; margin-left: auto; margin-right: auto; margin-top: 20px; opacity: 0.2;" alt="">

            <h1 style="margin-top: 0px;">Öffnet die <br><span
                    style="border-bottom: 5px #e53e3e solid; line-height: 1; display: inline-block; font-weight: 700;">Bundesgärten!</span>
            </h1>
            <br>
            <h2>Wie viel Sicherheitsabstand <br>darf's denn sein?</h2>
            Alle sollen <span style="color: #e53e3e; font-weight: bold;">{{ distance }} Meter</span> Sicherheitsabstand
            halten
            <vue-slider style="width: 90%; max-width: 300px; margin: 30px auto;" height="10px" dotSize="20" min="1"
                        :marks="marks" max="30"
                        :process-style="{ backgroundColor: '#e53e3e' }"
                        :tooltip-style="{ backgroundColor: '#e53e3e', borderColor: '#e53e3e' }"

                        v-model="distance"></vue-slider>
            <br>

            <div style="text-align: right; max-width: 450px; font-size: 0.8rem; font-weight: bold; margin: 20px auto; margin-bottom: -10px;">gleichzeitige<br> Besucher*innen</div>
            <div :key="park.name" v-for="park in parks" style="clear: both; max-width: 450px; margin: 20px auto; padding-top: 10px; border-top: 1px #CCC solid;">
                <div style="width: 50%; float: left; text-align: left; margin-bottom: 10px; ">
                    <strong style="font-size: 1.2rem;">{{ park.title}}</strong><br>
                    <span style="color: #AAA; font-weight: bold;">{{ park.size | formatNumber }}m²</span>
                </div>
                <div style="width: 50%; float:left; text-align: right; font-size: 1.3rem; padding-top: 10px;">
                   {{ Math.floor(park.size/(distance*distance)) | formatNumber }}
                </div>

                <br>
            </div>

            <div style="clear: both; max-width: 450px; margin: 20px auto; padding-top: 10px; border-top: 1px #000 solid;">
                <div style="width: 50%; float: left; text-align: left; margin-bottom: 10px; padding-top: 10px; ">
                    <strong style="font-size: 1.2rem;">Gesamtkapazität</strong><br>
                </div>
                <div style="width: 50%; float:left; text-align: right; font-size: 1.3rem; padding-top: 10px; font-weight: bold">
                    {{ totalPeople | formatNumber }}
                </div>

                <br>
            </div>

            <p style="clear: both; font-size: 12px; margin-top: 60px; display: inline-block; max-width: 400px; color: #888;"><strong style="font-size: 14px; color: #555;">Hinweis:</strong><br>Die Berechnung bezieht sich auf die Gesamtgröße des Parks und berücksichtigt Flächen die ~offiziell~ nicht betreten werden nicht, da hierzu nicht
            ausreichend Daten gefunden werden konnten.</p>

            <img src="../assets/divider.svg" style="width: 100%; margin-left: auto; margin-right: auto; margin-top: 30px; opacity: 0.2; transform: rotate(180deg)" alt="">

        </div>
    </main>

</template>

<script>
    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        computed: {
            totalPeople: function () {
                let count = 0;
                this.parks.forEach((park) => {
                    count += Math.floor(park.size / (this.distance * this.distance));
                });
                return count;
            }
        },
        data() {
            return {
                distance: 6,
                marks: [0, 10, 20, 30],
                parks: [
                    {
                        title: 'Schönbrunn',
                        size: 1600000
                    },
                    {
                        title: 'Augarten',
                        size: 522000
                    },
                    {
                        title: 'Belvedere',
                        size: 165270
                    },
                    {
                        title: 'Volksgarten',
                        size: 50000
                    },
                    {
                        title: 'Burggarten',
                        size: 40000

                    },
                ]
            };
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .container {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        border-radius: 10px;
        box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.3);

        z-index: 100;
        position: relative;
        padding: 30px;
        background-color: white;
        display: block;
    }

    h1 {
        font-weight: 500;
        font-size: 2rem;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
